import z from "zod";

export const maintenanceWorkflowForwardingCancelSchema = z.object({
  establishment_rejected_reason: z.string({ message: 'Campo obrigatório' }).min(8, { message: 'Tamanho mínimo: 8 caracteres' }),
});

export type MaintenanceWorkflowForwardingCancelSchemaValidationSchema = z.infer<typeof maintenanceWorkflowForwardingCancelSchema>;